<main class="main-root">
    <button class="btn btn-primary mt-5" id="get-touch" (click)="openModal(content)" hidden>Get In Touch</button>
</main>

<ng-template class="custom-modal-form" #content let-modal>
  <div class="modal-header">
    <div class="modal-header-lft">
      <h4 class="modal-title" id="modal-basic-title">{{ 'Book a session' | translate }} <br> {{ 'with our consultant' | translate }}</h4>
    </div>
    <button
      type="button"
      class="btn-close"
      aria-label="Close"
      title="{{ 'Close Modal' | translate }}"
      (click)="sendUpdate();modal.dismiss('Cross click')"
    ></button>
  </div>
  <div class="modal-body">
    <div class="cst-heading-desc-dv">
      <p>{{ 'HUNGERY is built to revolutionize FnB industry' | translate }}. <br> {{ 'And we are backed by 20 years of FnB experience' | translate }}.</p>
      <p>{{ 'Let\'s chat and see how we can help your business grow' | translate }}.</p>
    </div>
      
    <form [formGroup]="formGroup" (ngSubmit)="onSubmit()" class="cst-form-root-dv">
      <div class="cst-form-root-inner">
        <div class="row modal-form-row">
          <div class="col-12">
            <div class="form-inner-group nav-cta-wrap">
              <ng-select 
                formControlName="Topic"
                class="ng-form-select custom people-select" 
                [placeholder]="'Topic of enquiry' | translate"
                [class.is-invalid]="isFieldInvalid('Topic')">
                <ng-option *ngFor="let people of peoples" [value]="people.id">{{people.name}}</ng-option>
              </ng-select>
              <div *ngIf="isFieldInvalid('Topic')" class="invalid-feedback d-block">
                {{ getErrorMessage('Topic') }}
              </div>
            </div>
          </div>

          <div class="col-12">
            <div class="form-inner-group">
              <app-input
                [inputType]="'text'"
                [fieldValue]="formGroup.get('Name')?.value"
                [fieldText]="'Name' | translate"
                [fControl]="formGroup.controls['Name']"
                [inputClass]="'form-control'"
                [inputPlaceholder]="'Name' | translate"
                [labelClass]="'form-label'"
                (onTextChange)="onTextValueChange({field: 'Name', value: $event})"
                [maxLengthValidationMsg]="'Name must be at most 50 characters long.' | translate"
                [customErrorValidationMsg]="'Name must contain only alphabets' | translate"
                appAlphabetOnly
                tabindex="2"
                (keydown.enter)="$event.preventDefault()"
              ></app-input>
            </div>
          </div>

          <div class="col-12">
            <div class="form-inner-group">
              <app-input
                [inputType]="'email'"
                [fieldValue]="formGroup.get('Email')?.value"
                [fieldText]="'email' | translate"
                [fControl]="formGroup.controls['Email']"
                [inputClass]="'form-control'"
                [inputPlaceholder]="'Email' | translate"
                [labelClass]="'form-label'"
                (onTextChange)="onTextValueChange({field: 'Email', value: $event})"
                [customErrorValidationMsg]="'Email is invalid' | translate"
                [patternValidationMsg]="'Email is invalid' | translate"
                [maxLengthValidationMsg]="'Email must be at most 50 characters long.' | translate"
                tabindex="3"
                (keydown.enter)="$event.preventDefault()"
              ></app-input>
            </div>
          </div>

          <div class="col-12">
            <div class="form-inner-group phone-number-dv">
              <div class="form-inner-group nav-cta-wrap">
                <ng-select 
                  [(ngModel)]="getphoneSelect" 
                  [ngModelOptions]="{standalone: true}"
                  class="ng-form-select custom people-select" 
                  [placeholder]="'+62' | translate">
                  <ng-option *ngFor="let getphone of getphones" [value]="getphone.name">{{getphone.name}}</ng-option>
                </ng-select>
              </div>
              <div class="phone-grid-col">
                <app-input
                  [inputType]="'number'"
                  [fieldValue]="formGroup.get('Phone')?.value"
                  [fieldText]="'Phone Number' | translate"
                  [fControl]="formGroup.controls['Phone']"
                  [inputClass]="'form-control'"
                  [inputPlaceholder]="'Phone Number' | translate"
                  [labelClass]="'form-label'"
                  (onTextChange)="onTextValueChange({field: 'Phone', value: $event})"
                  [customErrorValidationMsg]="'Phone number is invalid' | translate"
                  [patternValidationMsg]="'Phone number must contain only digits' | translate"
                  [maxLengthValidationMsg]="'Phone number must be at most 15 characters long.' | translate"
                  tabindex="4"
                  (keydown.enter)="$event.preventDefault()"
                ></app-input>
              </div>
            </div>
          </div>

          <div class="col-12">
            <div class="form-inner-group">
              <app-input
                [inputType]="'text'"
                [fieldValue]="formGroup.get('Business Name')?.value"
                [fieldText]="'Business Name' | translate"
                [fControl]="formGroup.controls['Business Name']"
                [inputClass]="'form-control'"
                [inputPlaceholder]="'Business Name' | translate"
                [labelClass]="'form-label'"
                (onTextChange)="onTextValueChange({field: 'Business Name', value: $event})"
                [maxLengthValidationMsg]="'Business Name must be at most 100 characters long.' | translate"
                tabindex="5"
                (keydown.enter)="$event.preventDefault()"
              ></app-input>
            </div>
          </div>

          <div class="col-12">
            <div class="form-inner-group">
              <textarea 
                class="form-control" 
                formControlName="Notes" 
                [placeholder]="'Notes' | translate"
                [class.is-invalid]="isFieldInvalid('Notes')"
              ></textarea>
              <p class="prg-txt-blk">
                <span class="count-txt">{{notesCurrentLength}}</span> 
                <span class="total-txt">/ {{notesMaxLength}}</span>
              </p>
              <div *ngIf="isFieldInvalid('Notes')" class="invalid-feedback d-block">
                {{ getErrorMessage('Notes') }}
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="git-btn-btm-dv mt-4">
        <div class="privacy-info-text-dv">
          <p>{{ 'By submiting the form, you accept our privacy policy and consent to be contacted by HUNGERY' | translate }}</p>
        </div>
        <div class="btn-dv">
          <button 
            type="submit"
            class="btn btn-primary w-100 btn-lg"
            [disabled]="!formGroup.valid"
          >
            {{ 'Submit' | translate }}
          </button>
        </div>
      </div>
    </form>
  </div>
</ng-template>
  